import React from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { StyleSheet, Platform, StatusBar } from 'react-native';
import { useNavigationState } from '@react-navigation/native';
import { SystemBars } from 'react-native-edge-to-edge';

interface SafeAreaWrapperProps {
  children: React.ReactNode;
  edges?: ('top' | 'right' | 'bottom' | 'left')[];
  style?: any;
  statusBarStyle?: 'default' | 'light-content' | 'dark-content';
  backgroundColor?: string;
}

const SafeAreaWrapper: React.FC<SafeAreaWrapperProps> = ({
  children,
  edges,
  style,
  backgroundColor,
  statusBarStyle,
}) => {
  const activeRoute = useNavigationState(state => {
    const getActiveRoute = (navState: any): any => {
      const active = navState?.routes?.[navState?.index ?? 0];
      if (active?.state) return getActiveRoute(active.state);
      return active;
    };
    return getActiveRoute(state as any);
  });

  const onboardingSafeAreaColor =
    activeRoute?.name === 'Onboarding'
      ? activeRoute?.params?.onboardingColor
      : undefined;
  const onboardingStatusBarStyle =
    activeRoute?.name === 'Onboarding'
      ? activeRoute?.params?.statusBarStyle
      : undefined;

  const resolvedBackgroundColor =
    backgroundColor ?? onboardingSafeAreaColor ?? '#fff';
  const resolvedStatusBarStyle =
    statusBarStyle ?? onboardingStatusBarStyle ?? 'light-content';

  const defaultEdges = ['right', 'left', 'bottom'] as const;
  const safeAreaEdges = edges || defaultEdges;

  return (
    <SafeAreaView
      edges={safeAreaEdges}
      style={[
        styles.safeArea,
        { backgroundColor: resolvedBackgroundColor },
        style,
      ]}>
      {Platform.OS === 'android' ? (
        <SystemBars
          style={resolvedStatusBarStyle === 'dark-content' ? 'dark' : 'light'}
          // backgroundColor={resolvedBackgroundColor}
        />
      ) : (
        <StatusBar
          barStyle={resolvedStatusBarStyle}
          backgroundColor={resolvedBackgroundColor}
          translucent={true}
          animated={true}
        />
      )}
      {children}
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    flexGrow: 1,
  },
});

export default SafeAreaWrapper;
